import React from "react"
import Card from "@irati/ui/src/Layout/Card"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import {NestedRoute} from "@irati/utils/history/routing"
import {match as Match} from "react-router-dom"
import GroupCelebrationPopup from "../../../components/Popup/ScheduledGroupCelebration/Popup"
import ScheduledGroupCelebrationsList from "./ScheduledGroupCelebrations"

interface Props extends InjectIntlProps {
  match: Match
}

const ScheduledGroupCelebrationsListContainer = () => (
  <Card tiny noBorder>
    <DisablePointerEventsOnScroll>
      <ScheduledGroupCelebrationsList />
    </DisablePointerEventsOnScroll>
  </Card>
)
const MyScheduledGroupCelebrations: React.FC<Props> = (props) => {
  return (
    <>
      <NestedRoute
        useGrid={false}
        match={props.match.url}
        path="/:uuid?"
        title="Scheduled Group Celebrations"
        component={ScheduledGroupCelebrationsListContainer}
      />
      <NestedRoute
        useGrid={false}
        match={props.match.url}
        path={`/:uuid/:editType(invite)?`}
        title="Group Celebration"
        component={GroupCelebrationPopup}
      />
    </>
  )
}

export default injectIntl(MyScheduledGroupCelebrations)
